import { render, staticRenderFns } from "./AppDashboardTiles.vue?vue&type=template&id=774f80c0&"
import script from "./AppDashboardTiles.vue?vue&type=script&lang=js&"
export * from "./AppDashboardTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports